import { Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { AdditionalFieldSelector } from '../AdditionalFieldSelector'
import { DetailedCRMAccountIntegrationMapping } from '../../../../../../../models/Account'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { ContactLinking } from '../../ContactLinking/ContactLinking'
import { IntegrationMappingFilterSection } from '../IntegrationMappingFilterSection'

interface AdditionalObjectsBodyProps {
  serviceId: IntegrationServiceId
  additionalObjectIndex: number
  isDisabled?: boolean
}

export const AdditionalObjectsBody: React.FC<AdditionalObjectsBodyProps> = ({ serviceId, additionalObjectIndex, isDisabled = false }) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const additionalObjectsMappings = watch('mappings.additionalObjects') as DetailedCRMAccountIntegrationMapping[]
  const additionalObjectsMapping = useMemo(() => additionalObjectsMappings?.[additionalObjectIndex], [additionalObjectsMappings, additionalObjectIndex])
  const additionalObjectFields = useMemo(() => (additionalObjectsMapping ? additionalObjectsMapping.fields : {}), [additionalObjectsMapping])
  const alreadyAddedFieldKeys = useMemo(() => Object.keys(additionalObjectFields || {}), [additionalObjectFields])

  return (
    <Container className='py-3'>
      <Row className='mb-4'>
        <AdditionalFieldSelector
          title='Add field'
          description={`Choose which ${getIntegrationDisplayName(serviceId)} fields to include. This helps your AI Assistant understand the data better.`}
          serviceId={serviceId}
          mappingObjectName='additionalObjects'
          mappingObjectIndex={additionalObjectIndex}
          alreadyAddedFields={alreadyAddedFieldKeys}
        />
      </Row>
      <Row className='mb-4'>
        <ContactLinking
          serviceId={serviceId}
          zocksObjectName={additionalObjectsMapping.objectName || 'Additional Object'}
          linkingKey='additionalObjects'
          linkingKeyIndex={additionalObjectIndex}
          isDisabled={isDisabled}
        />
      </Row>
      <Row className='mb-4'>
        <IntegrationMappingFilterSection
          serviceId={serviceId}
          mappingKey='additionalObjects'
          mappingObjectIndex={additionalObjectIndex}
          title='Create Filters'
          description='Set conditions to control which Salesforce contacts sync to Zocks. Multiple conditions are combined with AND logic.'
        />
      </Row>
    </Container>
  )
}
